import * as React from 'react';
import { CoreLinearProgressBar as CoreProgressBar } from '../internal/WixUiCoreComponents/components/CoreLinearProgressBar';
import { ProgressBarProps } from './types';
import { st, classes } from './ProgressBar.st.css';

/** ProgressBar component based on LinearProgressBar from wix-ui-core */
export class ProgressBar extends React.PureComponent<ProgressBarProps> {
  static displayName = 'ProgressBar';
  static defaultProps: ProgressBarProps = {
    value: 0,
    size: 'small',
  };

  render() {
    const { size, className, ...rest } = this.props;
    return (
      <CoreProgressBar
        className={st(classes.root, { size }, className)}
        {...rest}
      />
    );
  }
}
